// src/redux/companySession/companySessionSelectors.js

// ✅ Create Company Session
export const selectCreateCompanySessionData = (state) =>
  state?.companySession?.createCompanySession?.data;
export const selectCreateCompanySessionLoading = (state) =>
  state?.companySession?.createCompanySession?.loading;
export const selectCreateCompanySessionError = (state) =>
  state?.companySession?.createCompanySession?.error;

// ✅ Company Sessions List
export const selectCompanySessionsList = (state) =>
  state?.companySession?.getCompanySessions?.data || [];
export const selectCompanySessionsLoading = (state) =>
  state?.companySession?.getCompanySessions?.loading;
export const selectCompanySessionsError = (state) =>
  state?.companySession?.getCompanySessions?.error;
export const selectCompanySessionsTotal = (state) =>
  state?.companySession?.getCompanySessions?.total || 0;

// ✅ Company Session Detail
export const selectCompanySessionDetail = (state) =>
  state?.companySession?.getCompanySessionDetail?.data;
export const selectCompanySessionDetailLoading = (state) =>
  state?.companySession?.getCompanySessionDetail?.loading;
export const selectCompanySessionDetailError = (state) =>
  state?.companySession?.getCompanySessionDetail?.error;

// ✅ Particular Session Details (POST method)
export const selectParticularSessionDetails = (state) =>
  state?.companySession?.getParticularSessionDetails?.data;
export const selectParticularSessionDetailsLoading = (state) =>
  state?.companySession?.getParticularSessionDetails?.loading;
export const selectParticularSessionDetailsError = (state) =>
  state?.companySession?.getParticularSessionDetails?.error;

// ✅ Enable Tool Access
export const selectEnableToolAccessData = (state) =>
  state?.companySession?.enableToolAccess?.data;
export const selectEnableToolAccessLoading = (state) =>
  state?.companySession?.enableToolAccess?.loading;
export const selectEnableToolAccessError = (state) =>
  state?.companySession?.enableToolAccess?.error;

// ✅ Enable Support Document
export const selectEnableSupportDocumentData = (state) =>
  state?.companySession?.enableSupportDocument?.data;
export const selectEnableSupportDocumentLoading = (state) =>
  state?.companySession?.enableSupportDocument?.loading;
export const selectEnableSupportDocumentError = (state) =>
  state?.companySession?.enableSupportDocument?.error;

// ✅ Enable Assignment
export const selectEnableAssignmentData = (state) =>
  state?.companySession?.enableAssignment?.data;
export const selectEnableAssignmentLoading = (state) =>
  state?.companySession?.enableAssignment?.loading;
export const selectEnableAssignmentError = (state) =>
  state?.companySession?.enableAssignment?.error;

// ✅ Enable Company Session
export const selectEnableCompanySessionData = (state) =>
  state?.companySession?.enableCompanySession?.data;
export const selectEnableCompanySessionLoading = (state) =>
  state?.companySession?.enableCompanySession?.loading;
export const selectEnableCompanySessionError = (state) =>
  state?.companySession?.enableCompanySession?.error;

// ✅ Combined
export const selectCompanySessionState = (state) => state?.companySession;